/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// State
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IDashboardSlice {
	dashboardQueryParams: any;
	setDashboardQueryParams: (
		_dashboardQueryParams: any
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

const initialState = {
	dashboardQueryParams: {},
};

export const createDashboardSlice: StateCreator<
	TStore,
	[],
	[],
	IDashboardSlice
> = (set) => ({
	...initialState,
	setDashboardQueryParams: (_dashboardQueryParams: any) =>
		set({ dashboardQueryParams: _dashboardQueryParams }),
});
